function openKustomer () {
  const wind: any = window;
  if (typeof wind !== "undefined" && !!wind.Kustomer) {
    wind.Kustomer.open();
  }
};

export default openKustomer;